export default {
  name: 'AutoUpdateApiData',
  data () {
    return {
      autoUpdateApiDataOptions: {
        timeout  : 10 * 60 * 1000,
        autoStart: true,
        callback : 'getData',
        interval : null
      }
    }
  },
  watch  : {},
  methods: {
    startAutoUpdateApiData (cb) {
      let callback = null

      this.stopAutoUpdateApiData()

      if (typeof cb === 'function') {
        callback = cb
      } else if (typeof cb === 'string' && typeof this[cb] === 'function') {
        callback = this[cb]
      } else {
        // eslint-disable-next-line no-console
        console.warn('AutoUpdateApiData:: No valid callback function passed!')
        return
      }

      this.autoUpdateApiDataOptions.interval = setInterval(callback, this.autoUpdateApiDataOptions.timeout)
    },
    stopAutoUpdateApiData () {
      if (this.autoUpdateApiDataOptions.interval) {
        clearInterval(this.autoUpdateApiDataOptions.interval)
      }
    }
  },

  created () {
    if (!this.autoUpdateApiDataOptions.autoStart) return

    this.startAutoUpdateApiData(this.autoUpdateApiDataOptions.callback)
  },

  beforeDestroy () {
    this.stopAutoUpdateApiData()
  }

}
